export default __webpack_public_path__ + "static/media/lawyer.51b885f3.svg";